import cn from 'classnames';
import React from 'react';

import styles from './styles.module.less';

export default props => {
  const { progress, isComplete } = props;

  return (
    <div
      className={cn(
        styles.uploadProgressLoadingPanel,
        isComplete ? styles.isCompleted : ''
      )}
    >
      <div className={styles.uploadProgressCheck} />
      <div className={cn(styles.uploadProgressContainer, 'radius:medium')}>
        <div
          className={styles.uploadProgressBar}
          style={{ transform: `translateX(${-100 + progress}%)` }}
        />
      </div>

      <span className={styles.screenReaderOnly}>
        {isComplete
          ? 'Content loading complete'
          : `Content loading: currently at ${progress} percent`}
      </span>
    </div>
  );
};
